import React, { useEffect, useState } from 'react'
import Container from '@material-ui/core/Container'
import { H1, H4 } from '../../../../components/UI'
import { useDispatch, useSelector } from 'react-redux'
import jMoment from 'moment-jalaali'
import './chooseDate.css'
import Grid from '@material-ui/core/Grid'
import { Calendar } from 'react-modern-calendar-datepicker'
import TimesCard from '../Time/TimesCard'
import { makeStyles } from '@material-ui/core/styles'
import * as DatesAction from './../../DatesAction'
import * as FormAction from './../../FormAction'
import 'react-modern-calendar-datepicker/lib/DatePicker.css'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import I18n from 'i18n-js'

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />
}

const useStyles = makeStyles((theme) => ({
	root: {
		minWidth: 275,
		maxWidth: 696,
		marginBottom: 40
	},

	header: {
		[theme.breakpoints.up('md')]: {
			textAlign: 'center'
		}

	}

}))

const ChooseDate = (props) => {
	const dispatch = useDispatch()
	const classes = useStyles()
	const [open, setOpen] = useState(false)
	const {
		language,
		currency,
		timezone
	} = useSelector(state => state.SettingsReducer)
	const {
		dates,
		datesTimeRanges
	} = useSelector(state => state.DatesReducer)
	const {
		calendarDate,
		date,
		time,
		counseling_center_username,
		consultant_username,
		service_id
	} = useSelector(state => state.FormReducer)

	useEffect(() => {
		dispatch(
			DatesAction.datesFetch(
				counseling_center_username,
				consultant_username,
				service_id,
				language,
				currency,
				timezone
			)
		)
	}, [])
	useEffect(() => {
		if (dates.length) {
			const defaultDay = jMoment(dates[0], 'YYYY-MM-DD').format('jYYYY-jMM-jDD')
			const [year, month, day] = defaultDay.split('-')
			dispatch(FormAction.setDate({
				day: parseInt(day),
				month: parseInt(month),
				year: parseInt(year)
			}))
		}
		console.log('______   ____', getTimeRanges('PM'))

	}, [dates])

	const getActiveDays = () => {

		let map = dates.map((date) => {
			if (!datesTimeRanges[date].length) {
				return null
			}
			date = jMoment(date, 'YYYY-MM-DD').format('jYYYY-jMM-jDD')
			const [year, month, day] = date.split('-')
			return {
				day: parseInt(day),
				month: parseInt(month),
				year: parseInt(year),
				className: 'purpleDay'
			}
		})
		return map
	}

	const getTimeRanges = (time) => {
		if (!datesTimeRanges[date]) {
			return []
		}

		const timeRanges = datesTimeRanges[date].map((timeRange) => {
			let startAtJMoment = jMoment(timeRange.start_at, 'YYYY-M-D HH:mm:ss')
			if ((startAtJMoment.clone().format('HH') >= 12 && time === 'AM') ||
				(startAtJMoment.clone().format('HH') < 12 && time === 'PM')
			) {
				return null
			}

			const startAt = startAtJMoment.clone().format('HH:mm')
			const endAt = jMoment(timeRange.end_at, 'YYYY-M-D HH:mm:ss').format('HH:mm')
			return {
				start_at: startAt,
				end_at: endAt
			}
		}).filter((timeRange) => {
			return timeRange !== null
		})
		return timeRanges
	}

	const main = (
		<Container className={classes.root} maxWidth="md">
			<div className={classes.header}>
				<H1>{I18n.t('consultant.dateTitle')}</H1>
				<H4>{I18n.t('consultant.dateDescription')}</H4>
			</div>
			<div>
				<Snackbar open={open} autoHideDuration={4000} onClose={(event, reason) => {
					if (reason === 'clickaway') {
						return
					}

					setOpen(false)
				}}>
					<Alert onClose={() => setOpen(false)} severity="error">
						{open}
					</Alert>
				</Snackbar>
				<Grid container justify="center">
					<Calendar
						value={calendarDate}
						shouldHighlightWeekends
						locale="fa"
						customDaysClassName={getActiveDays()}
						minimumDate={{
							year: parseInt(jMoment().format('jYYYY')),
							month: parseInt(jMoment().format('jMM')),
							day: parseInt(jMoment().format('jDD'))
						}}
						onChange={(date) => {
							let gregorianDate = jMoment(`${date.year}-${date.month}-${date.day}`, 'jYYYY-jMM-jDD').format('YYYY-MM-DD')
							if (dates.includes(gregorianDate)) {
								dispatch(FormAction.setDate(date))
							} else {
								setOpen(I18n.t('consultant.dateError'))
							}
							setTimeout(() => {
								window.scrollTo(0, document.body.scrollHeight)
							}, 10)
						}}
					/>
				</Grid>
			</div>
			{
				calendarDate && (
					<div style={{ marginTop: 32 }}>
						<Grid container justify="center" spacing={3}>
							{getTimeRanges('AM').length !== 0 && <Grid item xs={12} sm={6}>
								<TimesCard
									time={'AM'}
									value={time}
									timeRanges={getTimeRanges('AM')}
									clicked={(time) => {
										dispatch(FormAction.setTime(time))
									}}
								/>
							</Grid>}
							{getTimeRanges('PM').length !== 0 && <Grid item xs={12} sm={6}>
								<TimesCard
									time={'PM'}
									value={time}
									timeRanges={getTimeRanges('PM')}
									clicked={(timeRange) => {
										dispatch(FormAction.setTime(timeRange))
									}}
								/>
							</Grid>}
						</Grid>
					</div>
				)
			}

		</Container>
	)

	return (
		<div>
			{main}
		</div>
	)
}

export default ChooseDate
